import React from 'react';

import { twMerge } from 'tailwind-merge';

import Button from 'components/button/button';
import { createLocale } from 'locales';
import Typography from 'components/typography/typography';
import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

import useFavoriteFreelancerForOrganization from 'state/remote/remote-organization/use-favorite-freelancer-for-organization';
import useUnfavoriteFreelancerForOrganization from 'state/remote/remote-organization/use-unfavorite-freelancer-for-organization';
import useFavoriteFreelancerForLocation from 'state/remote/remote-organization/use-favorite-freelancer-for-location';
import useUnfavoriteFreelancerForLocation from 'state/remote/remote-organization/use-unfavorite-freelancer-for-location';

import Pairtext from '../pairtext';

const localize = createLocale('organizationPlannerJobDetailsLocales');
const localizeOrganizationWeekPlanner = createLocale(
  'organizationWeekPlannerLocales',
);
const Profile: React.FC = () => {
  const {
    userContext: { data: user },
    jobContext: { data: job },
  } = useOrganisationJobDetail();

  const favoriteFreelancerForOrganizationMutation =
    useFavoriteFreelancerForOrganization();
  const unfavoriteFreelancerForOrganizationMutation =
    useUnfavoriteFreelancerForOrganization();
  const favoriteFreelancerForLocationMutation =
    useFavoriteFreelancerForLocation();
  const unfavoriteFreelancerForLocationMutation =
    useUnfavoriteFreelancerForLocation();

  const onFavoriteFreelancerForOrganizationClicked = () => {
    if (job.assigned_to) {
      favoriteFreelancerForOrganizationMutation.mutate({
        organizationId: job.organisation.id,
        userId: job.assigned_to.id,
      });
    }
  };
  const onUnfavoriteFreelancerForOrganizationClicked = () => {
    if (job.assigned_to) {
      unfavoriteFreelancerForOrganizationMutation.mutate({
        organizationId: job.organisation.id,
        userId: job.assigned_to.id,
      });
    }
  };

  const onFavoriteFreelancerForLocationClicked = () => {
    if (job.assigned_to) {
      favoriteFreelancerForLocationMutation.mutate({
        locationId: job.location.id,
        userId: job.assigned_to.id,
      });
    }
  };
  const onUnfavoriteFreelancerForLocationClicked = () => {
    if (job.assigned_to) {
      unfavoriteFreelancerForLocationMutation.mutate({
        locationId: job.location.id,
        userId: job.assigned_to.id,
      });
    }
  };

  return (
    <div className="bg-white flex-1 border-gray200/60 border-2 pt-4 px-3 md:px-6 pb-8 flex flex-col flex-wrap gap-6 rounded-md">
      <Typography variant="body-large-bold" as="p">
        {localize('freelancer')}
      </Typography>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-3 xl:gap-x-16">
        <div className="flex gap-3">
          <img
            src={user.picture}
            alt={user.name}
            className="h-16 w-16 object-cover border-solid border-2 border-destructive rounded-full bg-contain text-caption flex items-center justify-center text-center"
          />
          <div className="flex flex-col flex-wrap gap-1">
            <Typography
              variant="body-large-bold"
              as="p"
              className="text-gray800/90"
            >
              {user.name}
            </Typography>
            <Typography
              variant="body-medium"
              as="p"
              className="text-gray400/70"
            >
              {localize('perHourVAT', { count: user.rate })}
            </Typography>
          </div>
        </div>
        <Pairtext Title="Email" Value={user.email} />
        <Pairtext Title={localize('phoneNumber')} Value={user.phone_number} />
        <Pairtext Title={localize('kvkNumber')} Value={user.kvk_nummer} />
      </div>

      <div className="flex gap-5 flex-col">
        <Button
          variant="outlined"
          label={
            job.is_favorite
              ? localizeOrganizationWeekPlanner(
                  'jobPopoverUnfavoriteFreelancerForOrganization',
                )
              : localizeOrganizationWeekPlanner(
                  'jobPopoverFavoriteFreelancerForOrganization',
                )
          }
          leftIconProps={{
            className: twMerge(job.is_favorite && 'text-destructive'),
            color: 'red',
            icon: job.is_favorite ? 'heart-twotone' : 'heart',
          }}
          onClick={
            job.is_favorite
              ? onUnfavoriteFreelancerForOrganizationClicked
              : onFavoriteFreelancerForOrganizationClicked
          }
          className="w-fit"
        />
        <Button
          variant="outlined"
          label={
            job.is_location_favorite
              ? localizeOrganizationWeekPlanner(
                  'jobPopoverUnfavoriteFreelancerForLocation',
                )
              : localizeOrganizationWeekPlanner(
                  'jobPopoverFavoriteFreelancerForLocation',
                )
          }
          leftIconProps={{
            className: twMerge(job.is_favorite && 'text-destructive'),
            color: 'red',
            icon: job.is_location_favorite ? 'heart-twotone' : 'heart',
          }}
          onClick={
            job.is_location_favorite
              ? onUnfavoriteFreelancerForLocationClicked
              : onFavoriteFreelancerForLocationClicked
          }
          className="w-fit"
        />
      </div>
    </div>
  );
};

export default Profile;
